import { PERMISSIONS } from '~/constants/permissions.constants';

export var SETTINGS_SECTIONS = [
  {
    key: 'conta',
    label: 'Conta',
    color: '#1890ff', bg: '#f0f5ff',
    items: [
      {
        key: 'minha-conta', path: '/configuracoes/perfil', label: 'Minha Conta', icon: 'user', description: 'Perfil, email e senha de acesso',
        children: [
          { key: 'perfil', path: '/configuracoes/perfil', label: 'Informações Pessoais', icon: 'user' },
          { key: 'senha', path: '/configuracoes/senha', label: 'Alterar Senha', icon: 'lock' },
        ]
      },
      { key: 'plano', path: '/configuracoes/plano', label: 'Plano', icon: 'crown', description: 'Gerencie sua assinatura e plano', disabled: true, comingSoon: true },
    ]
  },
  {
    key: 'empresa',
    label: 'Empresa',
    color: '#fa8c16', bg: '#fff7e6',
    items: [
      {
        key: 'empresa', path: '/configuracoes/empresa/dados', label: 'Dados da Empresa', icon: 'bank', permission: PERMISSIONS.settings.empresa.view, description: 'Razão social, CNPJ, endereço e WhatsApp',
        children: [
          { key: 'dados', path: '/configuracoes/empresa/dados', label: 'Dados da Empresa', icon: 'bank' },
          { key: 'whatsapp', path: '/configuracoes/empresa/whatsapp', label: 'WhatsApp', icon: 'message' },
        ]
      },
      { key: 'usuarios', path: '/configuracoes/usuarios', label: 'Usuários', icon: 'team', permission: PERMISSIONS.users.view, description: 'Gerenciar contas de usuários e convites' },
      { key: 'permissoes', path: '/configuracoes/permissoes', label: 'Permissões', icon: 'safety', permission: PERMISSIONS.settings.permissoes.view, description: 'Gerenciar grupos e níveis de acesso' },
    ]
  },
  {
    key: 'sistema',
    label: 'Sistema',
    color: '#722ed1', bg: '#f9f0ff',
    items: [
      {
        key: 'tarefas-do-checklist',
        path: '/configuracoes/tarefas-do-checklist/entrada',
        label: 'Tarefas do Checklist',
        icon: 'check-square',
        permission: PERMISSIONS.settings.checklistTasks.view,
        description: 'Configurar tarefas de entrada e saída',
        children: [
          { key: 'entrada', path: '/configuracoes/tarefas-do-checklist/entrada', label: 'Entrada', icon: 'login' },
          { key: 'entrada-troca', path: '/configuracoes/tarefas-do-checklist/entrada-troca', label: 'Entrada (Troca)', icon: 'swap' },
          { key: 'saida-encerramento', path: '/configuracoes/tarefas-do-checklist/saida-encerramento', label: 'Saída (Encerramento)', icon: 'logout' },
          { key: 'saida-troca', path: '/configuracoes/tarefas-do-checklist/saida-troca', label: 'Saída (Troca)', icon: 'retweet' },
        ]
      },
      {
        key: 'etapas-do-societario',
        path: '/configuracoes/etapas-do-societario/alteracao',
        label: 'Etapas do Societário',
        icon: 'ordered-list',
        permission: PERMISSIONS.settings.societarioStages.view,
        description: 'Etapas e siglas de cada tipo de ticket',
        children: [
          { key: 'abertura', path: '/configuracoes/etapas-do-societario/abertura', label: 'Abertura', icon: 'plus-circle' },
          { key: 'alteracao', path: '/configuracoes/etapas-do-societario/alteracao', label: 'Alteração', icon: 'edit' },
          { key: 'encerramento', path: '/configuracoes/etapas-do-societario/encerramento', label: 'Encerramento', icon: 'stop' },
          { key: 'troca-entrada', path: '/configuracoes/etapas-do-societario/troca-entrada', label: 'Troca (entrada)', icon: 'login' },
          { key: 'troca-saida', path: '/configuracoes/etapas-do-societario/troca-saida', label: 'Troca (saída)', icon: 'logout' },
          { key: 'tarefa', path: '/configuracoes/etapas-do-societario/tarefa', label: 'Tarefa esporádica', icon: 'profile' },
          { key: 'outros', path: '/configuracoes/etapas-do-societario/outros', label: 'Outros', icon: 'appstore' },
        ]
      },
      {
        key: 'extrato-bancario',
        path: '/configuracoes/extrato-bancario',
        label: 'Extrato Bancário',
        icon: 'bank',
        permission: PERMISSIONS.extratoBancario.view,
        description: 'Aba do portal do cliente e lembrete mensal',
      },
      {
        key: 'cadastro-de-tarefas',
        path: '/configuracoes/cadastro-de-tarefas',
        label: 'Cadastro de Tarefas',
        icon: 'form',
        permission: PERMISSIONS.settings.taskRegistration.view,
        description: 'Gerenciar tipos de tarefas disponíveis',
        hasAdd: true,
      },
      {
        key: 'variaveis',
        path: '/configuracoes/variaveis/origens',
        label: 'Variáveis do Sistema',
        icon: 'control',
        permission: PERMISSIONS.settings.systemVariables.view,
        description: 'Origens, categorias financeiras e mensalidades',
        hasAdd: true,
        children: [
          { key: 'origens', path: '/configuracoes/variaveis/origens', label: 'Origens', icon: 'global' },
          { key: 'categorias-contas-pagar', path: '/configuracoes/variaveis/categorias-contas-pagar', label: 'Contas a Pagar', icon: 'wallet' },
          { key: 'categorias-contas-receber', path: '/configuracoes/variaveis/categorias-contas-receber', label: 'Contas a Receber', icon: 'dollar' },
          { key: 'mensalidades', path: '/configuracoes/mensalidades', label: 'Módulo Mensalidades', icon: 'credit-card', hasAdd: false },
        ]
      },
      {
        key: 'docs-esporadicos',
        path: '/configuracoes/variaveis/docs/legalizacao',
        label: 'Documentos Esporádicos',
        icon: 'file-text',
        permission: PERMISSIONS.settings.sporadicDocs.view,
        description: 'Tipos de documentos esporádicos por departamento',
        hasAdd: true,
        children: [
          { key: 'legalizacao', path: '/configuracoes/variaveis/docs/legalizacao', label: 'Legalização', icon: 'audit' },
          { key: 'administrativo', path: '/configuracoes/variaveis/docs/administrativo', label: 'Administrativo', icon: 'solution' },
          { key: 'contabil', path: '/configuracoes/variaveis/docs/contabil', label: 'Contábil', icon: 'calculator' },
          { key: 'fiscal', path: '/configuracoes/variaveis/docs/fiscal', label: 'Fiscal', icon: 'file-protect' },
          { key: 'pessoal', path: '/configuracoes/variaveis/docs/pessoal', label: 'Pessoal', icon: 'team' },
          { key: 'sucesso-do-cliente', path: '/configuracoes/variaveis/docs/sucesso-do-cliente', label: 'Sucesso do Cliente', icon: 'customer-service' },
        ]
      },
    ]
  },
  {
    key: 'comercial',
    label: 'Comercial',
    color: '#13c2c2', bg: '#e6fffb',
    items: [
      { key: 'cadencias-prospeccao', path: '/configuracoes/variaveis/cadencias-prospeccao', label: 'Cadências Prospecção', icon: 'rocket', permission: PERMISSIONS.settings.systemVariables.view, description: 'Etapas da cadência de prospecção ativa', hasAdd: true },
      { key: 'cadencias-social-selling', path: '/configuracoes/variaveis/cadencias-social-selling', label: 'Cadências Social Selling', icon: 'share-alt', permission: PERMISSIONS.settings.systemVariables.view, description: 'Etapas da cadência de social selling', hasAdd: true },
    ]
  },
  {
    key: 'integracoes',
    label: 'Integrações',
    color: '#52c41a', bg: '#f6ffed',
    items: [
      { key: 'wpp', path: '/configuracoes/wpp', label: 'Extensão WhatsApp', icon: 'whatsapp', iconColor: '#25D366', iconBg: '#e6f9ee', description: 'Instalar e configurar a extensão WhatsApp' },
      { key: 'instagram', path: '/configuracoes/integracoes/instagram', label: 'Mensagens do Instagram', icon: 'instagram', iconColor: '#E1306C', iconBg: '#fff0f6', description: 'Conecte sua conta Instagram Business para receber mensagens no Social Selling e Prospecção Ativa' },
      { key: 'apify-instagram', drawer: 'apify-instagram', label: 'Buscar contatos pelo Instagram', icon: 'thunderbolt', iconColor: '#FF7A00', iconBg: '#fff7e6', description: 'Descubra novos leads automaticamente: extraia quem segue, curte e comenta em perfis estratégicos do Instagram' },
    ]
  },
  {
    key: 'sobre',
    label: 'Sobre',
    color: '#8c8c8c', bg: '#f5f5f5',
    adminOnly: true,
    items: [
      { key: 'versoes', path: '/configuracoes/versoes', label: 'Histórico de Versões', icon: 'history', adminOnly: true, description: 'Notas de atualização e changelog' },
    ]
  },
];

/**
 * Find a settings item by matching the current pathname.
 * Returns { section, item, child } or null.
 */
export var findSettingsItem = function(pathname) {
  for (var s = 0; s < SETTINGS_SECTIONS.length; s++) {
    var section = SETTINGS_SECTIONS[s];
    for (var i = 0; i < section.items.length; i++) {
      var item = section.items[i];
      // Check children first (more specific paths)
      if (item.children) {
        for (var c = 0; c < item.children.length; c++) {
          var child = item.children[c];
          if (pathname === child.path) {
            return { section: section, item: item, child: child };
          }
        }
      }
      // Check item path
      if (pathname === item.path) {
        return { section: section, item: item, child: null };
      }
    }
  }
  return null;
};

/**
 * Get the display title for a given pathname.
 */
export var getSettingsTitle = function(pathname) {
  var match = findSettingsItem(pathname);
  if (!match) return null;
  if (match.child) {
    return match.item.label + ' - ' + match.child.label;
  }
  return match.item.label;
};
